/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientUserViewModel } from '../../models/client-user-view-model';

export interface GetClientUser$Params {
  clientID: number;
  clientUserID: number;
}

export function GetClientUser(http: HttpClient, rootUrl: string, params: GetClientUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetClientUser.PATH, 'get');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.path('clientUserID', params.clientUserID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientUserViewModel>;
    })
  );
}

GetClientUser.PATH = '/api/Clients/GetClientUser/{clientID}/{clientUserID}';
